import React from "react";
var __jsx = React.createElement;
import { Fragment } from 'react';
import Anchor from '../../../../atoms/Anchor';
import List from '../../../../molecules/List/List';
import ListItem from '../../../../molecules/List/ListItem';
import PhoneIcon from '../../../../../static/images/icons/Phone';
import SmsIcon from '../../../../../static/images/icons/Comment';
import LocationIcon from '../../../../../static/images/icons/Location';
import EmailIcon from '../../../../../static/images/icons/Email';
import { getAddressURL, getCompleteAddress, convertPhoneFormat } from '../../../../../utils/utilityFunction';
import analyticsConstants from '../../../../../constants/analyticsConstants';
import { locationLabels } from '../../../../../constants/labels/en';
var footerAnalytics = analyticsConstants.globalFooter;
var contactInformationData = {
  Name: {
    Icon: LocationIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_ADDRESS,
    title: function title(address) {
      return address;
    },
    url: function url(addressUrl) {
      return addressUrl;
    }
  },
  AddressLine1: {
    Icon: LocationIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_ADDRESS,
    title: function title(address) {
      return address;
    },
    url: function url(addressUrl) {
      return addressUrl;
    }
  },
  AddressLine2: {
    Icon: LocationIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_ADDRESS,
    title: function title(address) {
      return address;
    },
    url: function url(addressUrl) {
      return addressUrl;
    }
  },
  PostalCode: {
    Icon: LocationIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_ADDRESS,
    title: function title(address) {
      return address;
    },
    url: function url(addressUrl) {
      return addressUrl;
    }
  },
  Email: {
    Icon: EmailIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_EMAIL,
    title: function title(email) {
      return email;
    },
    url: function url(email) {
      return "mailto:".concat(email);
    }
  },
  Fax: {
    Icon: PhoneIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_FAX,
    title: function title(fax) {
      return convertPhoneFormat(fax);
    },
    url: function url(fax) {
      return "tel:".concat(convertPhoneFormat(fax));
    }
  },
  Phone: {
    Icon: PhoneIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_PHONE,
    title: function title(phone) {
      return "".concat(convertPhoneFormat(phone));
    },
    url: function url(phone) {
      return "tel:".concat(convertPhoneFormat(phone));
    }
  },
  Text: {
    Icon: SmsIcon,
    dataAnalyticsType: footerAnalytics.analyticsType.GLOBAL_NAV,
    dataAnalyticsValue: footerAnalytics.analyticsValue.GLOBAL_NAV_PHONE,
    title: function title(sms) {
      return "".concat(convertPhoneFormat(sms));
    },
    url: function url(sms) {
      return "sms: ".concat(convertPhoneFormat(sms));
    }
  }
};
var ContactAnchor = function ContactAnchor(_ref) {
  var className = _ref.className,
    type = _ref.type,
    label = _ref.label,
    contactTitle = _ref.contactTitle,
    contactUrl = _ref.contactUrl,
    icon = _ref.icon;
  if (!contactTitle || !contactUrl) return;
  var _contactInformationDa = contactInformationData[type],
    Icon = _contactInformationDa.Icon,
    dataAnalyticsType = _contactInformationDa.dataAnalyticsType,
    dataAnalyticsValue = _contactInformationDa.dataAnalyticsValue;
  var url = contactInformationData[type].url(contactUrl);
  var title = contactInformationData[type].title(contactTitle);
  var ContactIcon;
  if (icon !== null && icon !== void 0 && icon.embedCode) {
    ContactIcon = function ContactIcon() {
      return __jsx("span", {
        className: "nva-footer__contact-icon",
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
          __html: icon.embedCode
        }
      });
    };
  } else if (icon !== null && icon !== void 0 && icon.image) {
    ContactIcon = function ContactIcon() {
      return __jsx("span", {
        className: "nva-footer__contact-icon"
      }, __jsx("img", {
        src: icon.image.url,
        alt: ""
      }));
    };
  } else {
    ContactIcon = function ContactIcon() {
      return __jsx("span", {
        className: "nva-footer__contact-icon"
      }, __jsx(Icon, null));
    };
  }
  return __jsx(ListItem, {
    className: className
  }, __jsx(Anchor, {
    removeDefaultStyles: true,
    title: title,
    ctaBehavior: "Open in a new page",
    className: "nva-footer__contact-item u-caption",
    to: url,
    "data-analytics-type": dataAnalyticsType,
    "data-analytics-value": dataAnalyticsValue
  }, __jsx(ContactIcon, null), label && __jsx("span", {
    className: "nva-footer__contact-label"
  }, label), " ", title));
};
var ContactItem = function ContactItem(_ref2) {
  var type = _ref2.type,
    label = _ref2.label,
    icon = _ref2.icon,
    contactData = _ref2.contactData;
  var _contactData$type = contactData === null || contactData === void 0 ? void 0 : contactData[type],
    className = _contactData$type.className,
    contactTitle = _contactData$type.title,
    contactUrl = _contactData$type.url;
  return __jsx(ContactAnchor, {
    className: className,
    type: type,
    label: label,
    contactTitle: contactTitle,
    contactUrl: contactUrl,
    icon: icon
  });
};
var getCompletePostalCode = function getCompletePostalCode(addressCity, addressRegion, addressPostalCode) {
  var completePostalCode = '';
  if (addressCity) {
    completePostalCode = addressCity;
  }
  if (addressRegion || addressPostalCode) {
    completePostalCode = "".concat(completePostalCode, ",");
  }
  if (addressRegion) {
    completePostalCode = "".concat(completePostalCode, " ").concat(addressRegion);
  }
  if (addressPostalCode) {
    completePostalCode = "".concat(completePostalCode, " ").concat(addressPostalCode);
  }
  return completePostalCode;
};
var ContactInformationFullWidth = function ContactInformationFullWidth(_ref3) {
  var _yextContactInformati, _yextContactInformati2, _yextContactInformati3, _yextContactInformati4, _yextContactInformati5;
  var items = _ref3.items,
    yextContactInformationData = _ref3.yextContactInformationData;
  var contactItems = items ? items : [{
    type: 'Address',
    label: locationLabels.addressCamelCase
  }, {
    type: 'Email',
    label: locationLabels.email
  }, {
    type: 'Fax',
    label: locationLabels.fax
  }, {
    type: 'Phone',
    label: locationLabels.phone
  }, {
    type: 'Text',
    label: locationLabels.sms
  }];
  var GMBUrl = (yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.c_googleMyBusinessCID) && "https://maps.google.com/maps?cid=".concat(yextContactInformationData.c_googleMyBusinessCID);
  var phone = (yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.c_websitePhone) || (yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.mainPhone);
  var sms = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.c_textPhone;
  var address = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.address;
  var fax = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.fax;
  var email = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.emails;
  var addressLine1 = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati = yextContactInformationData.address) === null || _yextContactInformati === void 0 ? void 0 : _yextContactInformati.line1;
  var addressLine2 = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati2 = yextContactInformationData.address) === null || _yextContactInformati2 === void 0 ? void 0 : _yextContactInformati2.line2;
  var addressCity = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati3 = yextContactInformationData.address) === null || _yextContactInformati3 === void 0 ? void 0 : _yextContactInformati3.city;
  var addressRegion = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati4 = yextContactInformationData.address) === null || _yextContactInformati4 === void 0 ? void 0 : _yextContactInformati4.region;
  var addressPostalCode = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati5 = yextContactInformationData.address) === null || _yextContactInformati5 === void 0 ? void 0 : _yextContactInformati5.postalCode;
  var nameItem = yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.name;
  var completePostalCode = getCompletePostalCode(addressCity, addressRegion, addressPostalCode);
  var addressString = address && getCompleteAddress(address.line1, address.line2, address.city, address.region, address.postalCode);
  var addressStringURL = getAddressURL(addressString);
  var contactData = {
    AddressLine1: {
      title: addressLine1,
      url: GMBUrl || addressStringURL,
      className: 'nva-footer__contact-address-line-1'
    },
    AddressLine2: {
      title: addressLine2,
      url: GMBUrl || addressStringURL,
      className: 'nva-footer__contact-address-line-2'
    },
    PostalCode: {
      title: completePostalCode,
      url: GMBUrl || addressStringURL,
      className: 'nva-footer__contact-postal-code'
    },
    Email: {
      title: email,
      url: email,
      className: 'nva-header__contact-email'
    },
    Fax: {
      title: fax,
      url: fax,
      className: 'nva-header__contact-fax'
    },
    Phone: {
      title: phone,
      url: phone,
      className: 'nva-footer__contact-phone'
    },
    Text: {
      title: sms,
      url: sms,
      className: 'nva-footer__contact-sms'
    },
    'Hours of Operation': {}
  };
  return __jsx("div", {
    className: "nva-footer__contact"
  }, __jsx("div", {
    className: "nva-footer__contact-wrapper"
  }, nameItem && __jsx("h3", {
    className: "nva-footer__contact-item-name"
  }, nameItem), __jsx(List, {
    className: "nva-footer__contact-list"
  }, contactItems.map(function (_ref4) {
    var type = _ref4.type,
      label = _ref4.label,
      icon = _ref4.icon;
    if (type === "Address") {
      return __jsx(Fragment, {
        key: type
      }, addressLine1 && __jsx(ContactItem, {
        type: "AddressLine1",
        label: label,
        icon: icon,
        contactData: contactData
      }), addressLine2 && __jsx(ContactItem, {
        type: "AddressLine2",
        label: label,
        icon: icon,
        contactData: contactData
      }), completePostalCode && __jsx(ContactItem, {
        type: "PostalCode",
        label: label,
        icon: icon,
        contactData: contactData
      }));
    }
    return __jsx(Fragment, {
      key: type
    }, __jsx(ContactItem, {
      type: type,
      label: label,
      icon: icon,
      contactData: contactData
    }));
  }))));
};
export default ContactInformationFullWidth;